// functions/uniqueEntires.ts
import { ValidationError } from "../errors/ValidationError.js";
import "../validator.js";
var uniqueEntries = (translationKey) => (options) => {
  if (!Array.isArray(options.value))
    throw new ValidationError(
      `Expected array, got ${typeof options}. validator uniqueEntries can only be used on array fields.`,
      { key: options.key, translationKey }
    );
  if (options.value.length !== new Set(options.value).size)
    throw new ValidationError(`Array ${options.key} does not have duplicate entries`, {
      key: options.key,
      translationKey
    });
};
export {
  uniqueEntries
};
